import { defineComponent as te, useSlots as ae, ref as b, toRef as re, watch as oe, computed as t, useAttrs as P, onMounted as le, openBlock as x, createElementBlock as w, createElementVNode as l, normalizeClass as s, mergeProps as se, toHandlers as ne, unref as ie, toDisplayString as N, createCommentVNode as T, renderSlot as ue, normalizeProps as de, guardReactiveProps as ce, nextTick as ve } from "vue";
import { watchThrottled as fe } from "@vueuse/core";
import { useNativeInput as me } from "../../composables/useNativeInput.js";
import { isEmpty as g } from "../../utils/isEmpty.js";
import { requestAnimationFrame as pe } from "../../utils/requestAnimationFrame.js";
import { tw as e } from "../../utils/tailwind.js";
const he = { class: "relative" }, be = { class: "body-1 flex w-full items-center" }, xe = ["id", "disabled", "required", "rows", "value"], we = ["for"], ge = ["role"], ye = ["id"], R = 24, H = 4, Ee = /* @__PURE__ */ te({
  name: "RevInputTextarea",
  inheritAttrs: !1,
  __name: "InputTextarea",
  props: {
    description: { default: "" },
    disabled: { type: Boolean, default: !1 },
    id: {},
    label: {},
    modelValue: {},
    rows: { default: 1 },
    maxRows: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid"],
  setup(o, { emit: L }) {
    const a = o, O = ae(), c = L, v = b(a.rows), f = b(null), q = b(null), i = b(null), u = re(a, "modelValue"), I = (r) => {
      i.value && f.value && f.value.setAttribute("data-cloned-val", r);
    }, d = me(i, u, {
      onInput: (r) => {
        c("update:modelValue", r.target.value), I(r.target.value), c("input", r);
      }
    });
    oe(
      d.invalid,
      (r, h) => {
        r ? c("invalid", i.value?.validity) : h && c("valid");
      },
      { immediate: !0 }
    );
    const y = t(() => Number(P().maxlength)), C = t(
      () => Number.isInteger(y.value) && y.value > 0
    ), V = t(() => C.value ? y.value - (a.modelValue !== void 0 ? a.modelValue : "").toString().length : Number.POSITIVE_INFINITY), E = t(() => C.value && O.count), S = t(
      () => C.value && V.value < 0
    ), B = t(() => !g(a.description)), m = t(() => !g(a.error)), z = t(
      () => d.touched.value && d.invalid.value
    ), k = t(() => B.value || m.value), D = t(() => E.value || k.value), n = t(
      () => S.value || z.value || m.value
    ), M = t(() => m.value ? a.error : a.description), W = t(() => {
      if (n.value)
        return `${a.id}_error`;
    }), F = t(
      () => typeof a.modelValue == "string" ? !g(a.modelValue) : !(typeof a.modelValue > "u")
    ), $ = P(), G = t(
      () => !g($.placeholder)
    ), p = t(
      () => d.focused.value || F.value || G.value
    ), X = t(() => [
      e`
    not-supports-[line-clamp-1]:after:max-h-[calc(var(--textarea-rows)*1.5em_+_30px)]
    after:line-clamp-[--textarea-rows]
  `,
      v.value === 1 ? e`after:min-h-[calc(var(--textarea-rows)*1.5em_+_24px)]` : e`after:min-h-[calc(var(--textarea-rows)*1.5em_+_28px)]`,
      e`
    w-full
    after:invisible after:overflow-hidden after:whitespace-pre-wrap after:border
    after:px-12 after:text-inherit after:content-[attr(data-cloned-val)_'_']
    after:[grid-area:1/1/2/2]
  `,
      // same as TEXTAREA_PADDING_BOTTOM
      p.value && e`after:pb-4 after:pt-24`,
      !a.disabled && !n.value && e`cursor-text`
    ]), Y = t(() => [
      X.value,
      e`peer group grid w-full`
    ]), j = t(() => [
      e`rounded-sm relative min-h-48 [grid-area:1/1/2/2]`,
      e`bg-static-default-low`,
      !a.disabled && e`group-hover:bg-static-default-low-hover group-has-[:hover]:bg-static-default-low-hover`,
      e`has-[:disabled]:bg-static-default-low-disabled`
    ]), J = t(() => [
      e`pointer-events-none absolute inset-0 rounded-sm border border-solid`,
      e`motion-safe:transition-colors motion-safe:duration-200`,
      e`peer-disabled:border-action-default-low-disabled`,
      !n.value && e`border-action-default-low peer-focus:border-action-default-low-pressed peer-focus:border-retina`,
      n.value && e`border-action-danger-low peer-focus:border-action-danger-low-pressed peer-focus:border-retina`
    ]), K = t(() => [
      e`peer rounded-sm input-normalize relative block w-full min-w-0 resize-none overflow-auto`,
      e`bg-transparent px-12 text-inherit outline-none`,
      e`disabled:text-action-default-hi-disabled`,
      // See TEXTAREA_PADDING_BOTTOM
      p.value && e`top-24 min-h-24 pb-4`,
      !p.value && e`min-h-48`,
      e`text-static-default-low`,
      e`motion-safe:transition-colors motion-safe:duration-200`
    ]), Q = t(() => [
      e`absolute inset-x-0 max-w-full -translate-y-1/2 truncate px-12`,
      e`peer peer-has-[:disabled]:text-action-default-hi-disabled`,
      p.value ? e`text-action-default-hi caption top-1 transform-none pt-8` : e`text-action-default-hi body-1 top-24`,
      !a.disabled && !n.value && e`cursor-text`,
      e`motion-safe:transition-all motion-safe:duration-200`
    ]), U = t(() => [
      e`body-2 mt-8 flex gap-16 motion-safe:transition-colors motion-safe:duration-200`,
      a.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]), Z = t(() => [
      e`grow whitespace-nowrap text-right`,
      !a.disabled && S.value && e`text-static-danger-hi`
    ]), ee = t(
      () => !a.disabled && n.value && e`text-static-danger-hi`
    );
    function A(r) {
      v.value = Math.min(
        r || a.rows || 1,
        a.maxRows || 1 / 0
      ), pe(() => {
        f.value?.style.setProperty(
          "--textarea-rows",
          v.value.toString()
        );
      });
    }
    async function _() {
      if (!u.value) {
        A(a.rows || 1);
        return;
      }
      await ve();
      const h = ((i.value?.scrollHeight || R + H) - H) / R;
      A(h);
    }
    return fe(
      u,
      () => {
        _();
      },
      {
        immediate: !0,
        // post means it happens after the DOM has been updated
        flush: "post",
        throttle: 200
      }
    ), le(() => {
      I(String(u.value || "")), _();
    }), (r, h) => (x(), w("div", null, [
      l("div", he, [
        l("div", be, [
          l("div", {
            ref_key: "textareaContainer",
            ref: f,
            class: s(Y.value),
            "data-cloned-val": ""
          }, [
            l("div", {
              ref_key: "borderWrapper",
              ref: q,
              class: s(j.value)
            }, [
              l("textarea", se(r.$attrs, {
                id: o.id,
                ref_key: "textarea",
                ref: i,
                class: K.value,
                disabled: o.disabled,
                required: o.required,
                rows: v.value,
                value: u.value
              }, ne(ie(d).listeners, !0), { onClick: _ }), null, 16, xe),
              l("div", {
                "aria-hidden": "true",
                class: s(J.value)
              }, null, 2)
            ], 2)
          ], 2),
          l("label", {
            class: s(Q.value),
            for: o.id
          }, N(o.label) + N(o.required ? " *" : ""), 11, we)
        ])
      ]),
      D.value ? (x(), w("p", {
        key: 0,
        "aria-live": "assertive",
        class: s(U.value),
        role: m.value ? "alert" : "presentation"
      }, [
        k.value ? (x(), w("span", {
          key: 0,
          id: W.value,
          class: s(ee.value)
        }, N(M.value), 11, ye)) : T("", !0),
        E.value ? (x(), w("span", {
          key: 1,
          class: s(Z.value)
        }, [
          ue(r.$slots, "count", de(ce({ count: V.value })))
        ], 2)) : T("", !0)
      ], 10, ge)) : T("", !0)
    ]));
  }
});
export {
  Ee as default
};
